/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-08 11:08:53                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-03 11:57:39                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
    * Components
  * Services
  * QuotationSection: dashboard section
*/

/* Imports */
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
/***/

/* Components */
import DashboardCardLayout from "../DashboardCardLayout";
import Loading from "../../../../../components/loading/Loading";
import QuotationDashdCard from "../../../../../components/data/quotation/QuotationDashCard";
/***/

/* Services */
import { createDateRangeQuery, searchWithFilters } from "../../../../../services/api/search";
/***/

/**
* QuotationsSection: dashboard section
* display invoices summarized informations
*/
export default function QuotationsSection({ from, to }: { from: Date; to: Date }) {
  const [quotations, setQuotation] = useState<EasyTech.Quotation[]>();
  const MAX_LENGTH = 3;
  const navigate = useNavigate();

  /**
  * useEffect: Get quotations list 
  * reload when the dashboard period changes
  */
  useEffect(() => {
    setQuotation(undefined);
    searchWithFilters<EasyTech.Quotation>("quotations", {
      paginate: { pageSize: MAX_LENGTH, pageNumber: 0 },
      order: { by: "date", direction: "DESC" },
      queries: [createDateRangeQuery("date", from, to)]
    })
      .then((ret) => setQuotation(ret.data))
      .catch((err) => {
        console.error(err);
        setQuotation([]);
      });
  }, [from, to]);
  /***/

  return(
    <div>
      <DashboardCardLayout  title={t("quotation:titleRequest")}
                            max={quotations ? quotations.length : 0}
                            current={MAX_LENGTH}
                            path="/quotations">
        <>
          {quotations ?
            quotations.length > 0 ?
              quotations.slice(0, MAX_LENGTH).map((el, i) => (
                <QuotationDashdCard key={"ref-"+i+"-"+el.ref}
                                    quotation={el}
                                    onClick={() => navigate(`/quotations/${el.id}`)}/>
              ))
            : <span className="no-item">{t("no quotation")}</span>
          : <Loading/>}
        </>
      </DashboardCardLayout>
    </div>
  );  
}
/***/
